export default __webpack_public_path__ + "static/media/room-sweet.7ede20d8.jpg";